import React from 'react';

function Loading(props) {
	if (props.error) {
		return <div className="loader-container">Error! Please refresh the page</div>;
	} else if (props.pastDelay) {
		return <div className="loader-container"> Loading ... </div>;
	} else {
		return null; // Avoiding Flash Of Loading Component (<200ms)
	}
};

export default Loading;